import { render, staticRenderFns } from "./AddFavorite.vue?vue&type=template&id=07c3280b&"
import script from "./AddFavorite.vue?vue&type=script&lang=js&"
export * from "./AddFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports